export enum ELoadingActionTypes {
	setLoading = "loading/setLoading"
}